module.exports = __webpack_public_path__ + "static/media/badge.46a31488.webp";